import { render, staticRenderFns } from "./OrgRelationshipModal.vue?vue&type=template&id=2017cb46&scoped=true&"
import script from "./OrgRelationshipModal.vue?vue&type=script&lang=js&"
export * from "./OrgRelationshipModal.vue?vue&type=script&lang=js&"
import style0 from "./OrgRelationshipModal.vue?vue&type=style&index=0&id=2017cb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017cb46",
  null
  
)

export default component.exports